<a
  routerLink="/inquiries/message-feed"
  matTooltip="Unread Messages. Click to view your messages in the Message Feed."
  matTooltipPosition="below"
  matTooltipClass="text-center">
  <i class="fal fa-envelope"></i>
  <sup [hidden]="!unreadCount" class="badge">{{unreadCount}}</sup>
</a>
